// extracted by mini-css-extract-plugin
export var carrierIcon = "_y5-0";
export var carrierLogo = "_y5-1";
export var detailsSection = "_y5-2";